import React from 'react';
import ProductDetailsHeader from './ProductDetailsHeader.component';

const MultiProductEditView = ({
	productCount,
	onDeleteProductCallback,
	collapseEastPanel,
}) => (
	<div>
		<ProductDetailsHeader
			headerText="Multiple Selections"
			productCount={productCount}
			onDeleteProductCallback={onDeleteProductCallback}
			collapseEastPanel={collapseEastPanel}
		/>
		<div className="form-container">
			<span className="products-multi-product-edit-view">
				{productCount} products selected
			</span>
		</div>
	</div>
);

export default MultiProductEditView;
